module.exports = __webpack_public_path__ + "static/logo-263eb009e3dd4e629cec5281001fbe5b.svg";